import React, {useState, useContext, useRef, useEffect} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonFooter } from '@ionic/react';
import { IonImg, IonLabel } from '@ionic/react';
import {Plugins, CameraResultType } from '@capacitor/core';

import { useHistory} from "react-router-dom";

import '../../../css/layout.css';
//import PublicShowcaseModal from '../components/AccountSetting_publicShowcase';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { UpdatePayMethod } from '../../../zInternal_Features/merchant/components/Modal_UpdatePayMethod';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';

import { PayModal_Subscription } from '../../../zInternal_Features/merchant/components/Modal_Pay_Subscription';
import { Modal_UpdateCompanyInfo } from '../../../zInternal_Features/merchant/components/Modal_UpdateCompanyInfo';

import { Preferences } from '@capacitor/preferences'


function setFunction_initialSetup(event) {

    Preferences.set({
        key: 'initial_setup',
        //value: event,
        value: JSON.stringify({
            setup_id: event[0],
            details: event[1],
            status: event[2],
            dateCreated: event[3],
            lastModified: event[4],
        })

    })

}

const { Filesystem } = Plugins;
const { Camera } = Plugins;


//export class Hotel_AccountSetting extends React.Component {
export function JobBoard_AccountSetting () {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [showInvoiceTemplates, setShowInvoiceTemplates] = useState(false);
    let [showFormTemplates, setShowFormTemplates] = useState(false);
    let [showCompanySetting_onlineImageModal, setShowCompanySetting_onlineImageModal] = useState(false);
    let [showCompanySetting_updateShowcaseModal, setShowCompanySetting_updateShowcaseModal] = useState(false);
    let [showCompanySetting_selectedImageModal, setShowCompanySetting_selectedImageModal] = useState(false);
    let [companyOnlineImage, setCompanyOnlineImage] = useState(null);
    let [enlarge_selectedShowcaseImage, setEnlarge_selectedShowcaseImage] = useState(null);

    let [updatePayMethodModal, setUpdatePayMethodModal] = useState(null);

    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);
    let [takePhotoStatus, setTakePhotoStatus] = useState(false);
    let [selectedFile, setSelectedFile] = useState(null);
    let [onlineImageAttachement, setOnlineImageAttachment] = useState('/var/www/web/Public/fileServer/merchants/attachment-not-available.png');

    let [viewSubscriptionBills, setViewSubscriptionBills] = useState([]);
    let [subscriptionID, setSubscriptionID] = useState(null);
    let [bill_dueDate, setBill_dueDate] = useState(null);
    let [bill_amount, setBill_amount] = useState(null);

    let [viewPayModalSubscription, setViewPayModalSubscription] = useState(false);

    let [zasavaCompanyID, setZasavaCompanyID] = useState('1')

    let [companyInfoModal, setCompanyInfoModal] = useState(false);

    let history = useHistory();

    useEffect(() => {

        let formData = new FormData();
        formData.append('Tracker', "00_accountSettings_retrieveSubscription");
        formData.append('user', acctID);
        formData.append('sessionID', sessionID);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        fetch(baseURL+'ghanaverified/', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');



                    setViewSubscriptionBills((prevViewBills) => {
                        return prevViewBills.concat({
                            globalID: cols[0],
                            employeeID: cols[1],
                            subscriptionID: cols[2],
                            payAmount: parseFloat(cols[3]).toFixed(2),
                            currency: cols[4],
                            paymentStatus: cols[5],
                            paymentMethod: cols[6],
                            transactionReference: cols[7],
                            paymentDate: cols[8] ? new Date(cols[8]).toISOString().substr(0, 10) : "",
                            nextBillingDate: cols[9] ? new Date(cols[9]).toISOString().substr(0, 10) : "",
                            createdAt: cols[10] ? new Date(cols[10]).toISOString().substr(0, 10) : "",
                            updatedAt: cols[11] ? new Date(cols[11]).toISOString().substr(0, 10) : "",

                        })
                    });
                } 
        })

    }, []);


    function confirmBillPay(event)
    {
        setViewPayModalSubscription(false);
    
    
            const requestOptions = {
                method: 'POST',
                //mode: 'no-cors',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                //headers: headers.append('Access-Control-Allow-Origin', 'https://bluefinhoteltest.com'), 
                //headers: headers.append('Access-Control-Allow-Origin', 'https://bluefinhoteltest.com'), 
                //headers: headers.append('content-type', 'application/json'), 
                body: JSON.stringify({
                    Tracker: '74706_merchant_subscription_complete_update',
                    user: acctID,
                    xSubscriptionID: subscriptionID,
                    xMerchantFirstName: authenticatedMerchent_context.employeeFirstName,
                    xMerchantLastName: authenticatedMerchent_context.employeeLastName,
                    xMerchantMobileNumber: authenticatedMerchent_context.companyPhoneNumber,
                    xPaymentType: "MTN-MOMO",
                    xMomo_amount: bill_amount,
                    xTransactionID: event[1],
                    sessionID: sessionID,
    
                }),
            }
    
            //alert('Inside GetAvaialbleRoom AFTER upload');
            //alert(baseURL);
    
    
            fetch(baseURL+'ghanaverified/', requestOptions)
            //fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
                
                alert("BILL PAY COMPLETE.")
    
                //alert(res);
        
            })
    
           history.push('/hotel_merchantMainPageApp');
    
    }

function handleEnterCompanyOnlineImage(e) {  

    if(e.target.files == null)
    {
        setCompanyOnlineImage("/var/www/web/Public/fileServer/merchants/image-not-available.jpg")
    }
    else
    {
        setCompanyOnlineImage(e.target.files[0])
    }
}

function saveUploadedFile(event) {
    
        setSelectedFile(event)

    }



    async function uploadFile() {

        alert('In UploadedFile');
        alert(selectedFile);

        let formData = new FormData();
        formData.append('xImageFile', selectedFile);
        formData.append('Tracker', '72003');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);

        })
    }
    function handleRoute(event)
    {
        //alert(authenticatedMerchent_context.authenticated);

        history.push(event);
        //window.location.pathname = event;

    }

    function uploadCompanySetting_onlineImage(e) {

       // alert(companyOnlineImage);
       e.preventDefault();


        let formData = new FormData();
        formData.append('Tracker', '74003B');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('sessionID', sessionID);
        formData.append('xImageFile', selectedFile);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                //'content-type': 'application/json',
             },
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
            /*body: JSON.stringify({
                Tracker: '72001B',
                user: acctID,
            })*/
        }

        fetch(baseURL+"jobBoard_merchantAcct_argsjqApp",requestOptions)
        .then(res => res.text())
        .then(res => {

            // alert(res);
            // alert(authenticatedMerchent_context.initialSetup?.details?.step_1);

            if(authenticatedMerchent_context.initialSetup?.details?.step_1 == false && res.trim() === 'ONLINE_IMAGE_UPDATED')
            {
                //alert("Inside authenticatedMerchent_context.initialSetup?.details?.step_1");
                updateInitialSetup({step_1: true, step_2: authenticatedMerchent_context.initialSetup?.details?.step_2, step_3: authenticatedMerchent_context.initialSetup?.details?.step_3, step_4: authenticatedMerchent_context.initialSetup?.details?.step_4});
            }
            else
            {
                handleRoute('/hotel_merchantMainPageApp');
            }
            
            //setShowCompanySetting_onlineImageModal(false);
        })
    }


    function updateInitialSetup(event) {

        // alert("in updateInitialSetup");
        // alert(event);
 
 
         let formData = new FormData();
         formData.append('Tracker', '74003B_update_initialSetup');
         formData.append('user', acctID);
         formData.append('xInitialSetup_id', authenticatedMerchent_context.initialSetup.setup_id);
         formData.append('xInitialSetup_details', JSON.stringify(event));
         formData.append('sessionID', sessionID);
 
 
         const requestOptions = {
             enctype: 'multipart/form-data',
             method: 'POST',
             credentials: 'include',
             headers: {
                 'Accept': 'text/html, application/json',
                 //'content-type': 'application/json',
              },
             file: formData,
             body: formData,
             contentType: false,
             processData: false,
             /*body: JSON.stringify({
                 Tracker: '72001B',
                 user: acctID,
             })*/
         }
 
         fetch(baseURL+"jobBoard_merchantAcct_argsjqApp",requestOptions)
         .then(res => res.text())
         .then(res => {
 

            let rows = res.toString().split('~~~');
            let lines3 = rows[0].split('|');
            
             setFunction_initialSetup([lines3[0], lines3[1], lines3[2], lines3[3], lines3[4]]);


             let initialSetupParsed = {};
                
             try {
             initialSetupParsed = JSON.stringify({
                 setup_id: lines3[0],
                 details: lines3[1],
                 status: lines3[2],
                 dateCreated: lines3[3],
                 lastModified: lines3[4],
             })
                 ? JSON.parse(JSON.stringify({
                     setup_id: lines3[0],
                     details: lines3[1],
                     status: lines3[2],
                     dateCreated: lines3[3],
                     lastModified: lines3[4],
                 })) : {};

             if (typeof initialSetupParsed.details === 'string') {
                 initialSetupParsed.details = JSON.parse(initialSetupParsed.details);
             }
             } catch (e) {
             console.warn('Error parsing initialSetup:', e);
             initialSetupParsed = {};
             }

          authenticatedMerchent_context.changeInitialSetup(initialSetupParsed); 
            
             alert("UPDATE COMPLETE");

             handleRoute('/jobBoard_merchantMainPageApp');
         })
     }

     
    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/attachment-not-available.png')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setOnlineImageAttachment(noImageFile);

        })
    }


    function handleFileChange(event) {

        // alert('In handleFileChange');
        // alert(event);
        // alert(event.target);
        // alert(event.target.files);
        //alert(event.target.file);
        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
        //setFileName(file ? file.name : '');
    }

    function handlePayBill(event)
    {
        setSubscriptionID(event[0]);
        setBill_dueDate(event[1]);
        setBill_amount(event[2]);
        setViewPayModalSubscription(true);
    }


    function selectedFileHandler(event)
    {
        setSelectedFile(event);

    }

    //alert('In Account Setting ');

    return (
            <React.Fragment>
                
            {/*<App_Header></App_Header>*/}

            <IonHeader style={{color: 'white'}}>
                <IonGrid>
                    {authenticatedMerchent_context.authenticated != null && <IonRow>
                        <IonCol style={{ textAlign: 'left' }} size='4'>
                            <IonTitle >{authenticatedMerchent_context.employeeCompany}</IonTitle>
                        </IonCol>
                        <IonCol style={{ textAlign: 'left' }} size='6'>
                            <IonTitle >{authenticatedMerchent_context.employeeFirstName + ' ' + authenticatedMerchent_context.employeeLastName}</IonTitle>
                        </IonCol>
                        <IonCol className='gh_top_links_col_right' size='2'>
                            <IonMenuButton className="custom-menu-button"  fill={'clear'}>M</IonMenuButton>
                        </IonCol>
                    </IonRow>}
                    <IonRow>
                        <IonCol>
                            <h3>ACCOUNT SETTINGS</h3>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>

            <IonContent className='grid_content'>
                <IonGrid>
                    {/*<IonRow>
                        <IonCol size='6'>
                            <h3>Upload Invoice Template</h3>
                        </IonCol>
                        <IonCol size='6'>
                            <form id='fileUpload' enctype='multipart/form-data'>
                                <input type='file' name='xImageFile' accept="image/*" onChange={(e) => saveUploadedFile(e.target.files[0])}></input>
                                <input type="button" value="upload" onClick={uploadFile} ></input>
                            </form>
                            <IonButton onClick={() => setShowInvoiceTemplates(true)}>View Invoice Uploaded</IonButton>
                        </IonCol>
                    </IonRow>*/}


                    <IonRow>
                        <IonCol size='12'>
                            <h3 >Billing</h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='4'>
                            <IonText >Due Date</IonText>
                        </IonCol>
                        <IonCol size='4'>
                            <IonText >Amount</IonText>
                        </IonCol>
                        <IonCol size='4'>
                            <IonText >Action</IonText>
                        </IonCol>
                    </IonRow>
                    {viewSubscriptionBills.map((detailData) =>   {
                            return (
                                    <IonRow key={detailData.subscriptionID}>
                                        <IonCol size='4'>
                                            <IonText>{detailData.nextBillingDate}</IonText>
                                        </IonCol>
                                        <IonCol size='4'>
                                            <IonText>{detailData.payAmount}</IonText>
                                        </IonCol>
                                        <IonCol size='4'>
                                            {detailData.paymentStatus == 'PAID' && <IonText >PAID</IonText>} 
                                            {detailData.paymentStatus == 'pending' && <IonButton onClick={() => handlePayBill([detailData.subscriptionID, detailData.nextBillingDate, detailData.payAmount])}>Pay Bill</IonButton>}
                                        </IonCol>
                                    </IonRow>
                            )
                        }
                        )}

                    <IonRow>
                        <IonCol size='12'>
                            <h3 size='large'>Payment Methods</h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonButton onClick={() => setUpdatePayMethodModal(true)}>Update</IonButton>
                        </IonCol>

                        {updatePayMethodModal == true && <UpdatePayMethod openModal={ updatePayMethodModal } closeModal={() => setUpdatePayMethodModal(false)} tracker={'74003A'} acctID={acctID}></UpdatePayMethod>}

                    </IonRow>


                    <IonRow>
                        <IonCol size='12'>
                            <h3 size='large'>Merchant Logo</h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                    {authenticatedMerchent_context.initialSetup?.details?.step_1 == false &&  <IonCol size='12'>
                            <IonButton className='flash-tutorial' onClick={() => setShowCompanySetting_onlineImageModal(true)}>Update Online Image</IonButton>
                        </IonCol>}
                    {authenticatedMerchent_context.initialSetup?.details?.step_1 == true &&  <IonCol size='12'>
                        <IonButton onClick={() => setShowCompanySetting_onlineImageModal(true)}>Update Online Image</IonButton>
                    </IonCol>}
                    </IonRow>

                    <IonRow>
                        <IonCol size='12'>
                            <h3 size='large'>Company Info</h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='12'>
                            <IonButton onClick={() => setCompanyInfoModal(true)}> Update Company Info</IonButton>
                        </IonCol>
                    </IonRow>



                </IonGrid>

                {viewPayModalSubscription == true && <PayModal_Subscription openModal={ viewPayModalSubscription } closeModal={() => setViewPayModalSubscription(false)} payCloseModal={(event) => confirmBillPay(event)} data={{
                    subscriptionID: subscriptionID,
                    companyId: zasavaCompanyID,
                    firstName: authenticatedMerchent_context.employeeFirstName, 
                    lastName: authenticatedMerchent_context.employeeLastName,
                    mobileNumber:  authenticatedMerchent_context.companyPhoneNumber,
                    payeeMessage: 'Monthly Subscription Payment',
                    paymentType: 'MTN-MOMO',
                    payment_amount: bill_amount,
                    }}></PayModal_Subscription>}

                {companyInfoModal == true && <Modal_UpdateCompanyInfo openModal={ companyInfoModal } closeModal={() => setCompanyInfoModal(false)}></Modal_UpdateCompanyInfo>}

            </IonContent>
            <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <IonButton onClick={() => handleRoute('/jobBoard_merchantMainPageApp')}> Close </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>

                <IonModal id='showCompanySetting_onlineImage' isOpen={showCompanySetting_onlineImageModal}>
                <form onSubmit={uploadCompanySetting_onlineImage}>

                        <IonGrid class="settingTable">
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus(true)}> Take Photo</IonButton>
                                {takePhotoStatus == true && <TakePhoto onSelectedFile={selectedFileHandler}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    onChange={handleFileChange}
                                    required
                                />
                            </IonCol>
                        </IonRow>
                        {/*<IonRow>
                            <form id='fileUpload' onSubmit={() => setShowPasswordModal(true)}>
                                <input type='file' name='xImageFile' accept="image/*" enctype='multipart/form-data' onChange={(e) => setSelectedFile(e.target.files[0])}></input>
                            </form>
                        </IonRow>*/}
                            <IonRow>
                                <IonCol>
                                {authenticatedMerchent_context.initialSetup?.details?.step_1 == false && <IonButton type='submit' className='flash-tutorial'> Save </IonButton>}
                                {authenticatedMerchent_context.initialSetup?.details?.step_1 == true && <IonButton onClick={() => uploadCompanySetting_onlineImage()}> Save </IonButton>}
                                </IonCol>
                                <IonCol>
                                    <IonButton onClick={() => setShowCompanySetting_onlineImageModal(false)}> Cancel </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                        </form>
                </IonModal>

                {/*{showCompanySetting_updateShowcaseModal == true &&<PublicShowcaseModal openModal= {showCompanySetting_updateShowcaseModal} closeModal={() => setShowCompanySetting_updateShowcaseModal(false)} onSetEnlarge_selectedShowcaseImage = { setEnlarge_selectedShowcaseImage }></PublicShowcaseModal>}*/}


                <IonModal id='showCompanySetting_selectedImage' isOpen={showCompanySetting_selectedImageModal}>
                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <IonImg
                                            class='zProServiceShowcase_img'
                                            src={enlarge_selectedShowcaseImage} 
                                        ></IonImg>
                                        <IonButton onClick={() => setShowCompanySetting_selectedImageModal(false)}> Close </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonModal>

            </React.Fragment>
            
    );
};



export default JobBoard_AccountSetting;